import React, { Component } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { RenderRoutes } from './routes/routes'
import GlobalContextProvider from './providers/GlobalContextProvider'

// Themes
import './assets/scss/DefaultTheme.scss'

const ROUTER_BASENAME = new URL(process.env.PUBLIC_URL || '/', window.location.origin).pathname.replace(/\/$/, '') || '/'


/**
 * Main app component
 */
class App extends Component {

  render() {
    return (<BrowserRouter basename={ROUTER_BASENAME}><GlobalContextProvider><RenderRoutes />
    </GlobalContextProvider></BrowserRouter>)
  }

}
export default App;
